let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dXu4x")).then(() => parcelRequire('9e0h0'));